import { AipIds } from '@harvestiq/constants';
import { z } from '@harvestiq/zod';
import { createFmhLrpEndorsementSchema } from '@harvestiq/external-clients-fmh-common';

const submitFmhLrpCoverageReqSchema = z.object({
  orgId: z.string(),
  orgSchema: z.string(),
  aip: z.nativeEnum(AipIds),
  coverageId: z.string().uuid(),
  insuredUserId: z.string().uuid(),
  agentUserId: z.string().uuid(),
  reinsuranceYear: z.number().int(),
  aipPolicyProducerKey: z.string(),
  aipInsuranceAgentKey: z.string(),
  aipInsuranceInForceKey: z.string(),
  endorsementRequest: createFmhLrpEndorsementSchema,
  coverageLevel: z.number(),
});

export const submitFmhLrpCoverageMsgSchema = z.object({
  orgId: z.string(),
  request: submitFmhLrpCoverageReqSchema,
});

export type SubmitFmhLrpCoverageMsg = z.infer<
  typeof submitFmhLrpCoverageMsgSchema
>;
